import React, { useState } from 'react';
import './AddPartnerModal.scss';

interface AddPartnerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (partnerData: { carrierCode: string; carrierName: string }) => void;
}

const AddPartnerModal: React.FC<AddPartnerModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  const [carrierCode, setCarrierCode] = useState('');
  const [carrierName, setCarrierName] = useState('');
  const [errors, setErrors] = useState({ carrierCode: '', carrierName: '' });

  if (!isOpen) return null;

  const validateForm = (): boolean => {
    const newErrors = {
      carrierCode: '',
      carrierName: ''
    };
    
    let isValid = true;

    if (!carrierCode.trim()) {
      newErrors.carrierCode = 'Carrier code is required';
      isValid = false;
    } else if (!/^[A-Z0-9]{2,3}$/.test(carrierCode.trim())) {
      newErrors.carrierCode = 'Carrier code must be 2-3 uppercase letters or numbers';
      isValid = false;
    }

    if (!carrierName.trim()) {
      newErrors.carrierName = 'Carrier name is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      onConfirm({
        carrierCode: carrierCode.trim(),
        carrierName: carrierName.trim()
      });
      // Reset form
      setCarrierCode('');
      setCarrierName('');
      setErrors({ carrierCode: '', carrierName: '' });
    }
  };

  return (
    <div className="add-partner-modal-overlay" role="presentation">
      <div
        className="add-partner-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="add-partner-modal-title"
      >
        <button
          className="add-partner-modal__close-button"
          onClick={onClose}
          aria-label="Close add partner modal"
        >
          ✕
        </button>
        <div className="add-partner-modal__header">
          <h2 id="add-partner-modal-title" className="add-partner-modal__title">
            Add a partner airline
          </h2>
        </div>
        
        <div className="add-partner-modal__content">
          <div className="add-partner-modal__form">
            <div className="add-partner-modal__form-group">
              <input
                type="text"
                id="carrierName"
                className={`add-partner-modal__input ${errors.carrierName ? 'add-partner-modal__input--error' : ''}`}
                value={carrierName}
                onChange={(e) => setCarrierName(e.target.value)}
                placeholder="Partner full name"
                aria-label="Partner full name"
              />
              {errors.carrierName && (
                <div className="add-partner-modal__error">{errors.carrierName}</div>
              )}
            </div>
            
            <div className="add-partner-modal__form-group">
              <input
                type="text"
                id="carrierCode"
                className={`add-partner-modal__input ${errors.carrierCode ? 'add-partner-modal__input--error' : ''}`}
                value={carrierCode}
                onChange={(e) => setCarrierCode(e.target.value.toUpperCase())}
                placeholder="Carrier code"
                maxLength={3}
                aria-label="Carrier code"
              />
              {errors.carrierName && (
                <div className="add-partner-modal__error">{errors.carrierName}</div>
              )}
            </div>
          </div>
        </div>
        
        <div className="add-partner-modal__footer">
          <div className="add-partner-modal__footer-container">
            <div className="add-partner-modal__footer-buttons">
              <auro-button
                className="add-partner-modal__add-button"
                onClick={handleSubmit}
                aria-label="Add partner airline"
                variant='primary'
                size='md'
              >
                Add partner airline
              </auro-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPartnerModal;